export const HEADER_NAME = 'Open a support ticket ';
export const SEGMENT_LABEL = 'Product segment:';
export const PRODUCT_SEGMENT = 'ONESOURCE';

export const TITLE_LABEL = 'Product title:';
export const PRODUCT_TITLE = 'ONESOURCE';
export const REQUIRED = '* Required field';

export const PAN = 'PAN Acct #';
export const PREF_CONTACT = '*Preferred contact method';
export const IMPACT = '*Impact';
export const FIRST_NAME_LABEL = '*First name';
export const LAST_NAME_LABEL = '*Last name';
export const EMAIL_LABEL = '*Email';
export const ALT_EMAIL = 'Alternate email';
export const ALT_PHONE = 'Alternate phone';
export const SUBJECT = '*Subject';
export const DESCRIPTION = '*Description';
export const LOCATOR = 'Locator#';
export const TAX_YR = 'Tax Year';
export const TAX_TYPE = 'Tax Type';
export const JURISDICTION = 'Jurisdiction';
export const TAX_FORM = 'Tax Form';
export const ENTITY_NAME = 'Entity Name/Number';
export const WORKAREA_NAME = 'Workarea Name/Number';
export const BINDER_NAME = 'Binder Name/Number';
export const PERMISSION_COPY = 'Permission to retrieve or copy return';
export const PERMISSION_UTILIZE = 'Permission to utilize copy of return';
export const PARTNER_ID = 'Partner/Legacy System Id';
export const PERMISSION_TRANSMIT = 'Permission to be re-transmit';
export const PRODUCT_BUG = 'Are you reporting a product bug?';
export const CRITICAL_PROCCESS = 'Preventing buisness-critical process?';
export const WORKAROUND = 'Is there a suitable workaround?';

export const CANCEL = 'Cancel';
export const SUBMIT = 'Open ticket';

export const TICKET_OPEN = 'Ticket Opened';
export const CASE_SUCCESS = 'Your ticket was successfully created and opened.';
export const HELP_BTN = 'Go back to Help and Support';
export const SUPPORT_BTN = ' Manage support tickets';

//Patterns
export const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const NAME_PATTERN = /^[a-zA-Z\s]+$/;

//Error Messages
export const EMAIL_ERR = 'Invalid email';
export const FIRST_NAME_ERR = 'Invalid first name';
export const LAST_NAME_ERR = 'Invalid last name';
export const ENTER = 'Enter';
export const API_ERROR_MSG =
  'There’s a technical issue on our end. The good news is we’re working on it. Try again.';

//APIs
export const CLIENT_ID = 'SShzZuItMEac1gdi8sU2VNyHY6dRvEKd';
export const CLIENT_SECRET = '4xAUqOLYyp49oSXk';
export const OAUTH_API =
  'https://api-test.thomsonreuters.com/chatbot/oauth/v1/token';
export const CASE_API =
  'https://api-test.thomsonreuters.com/digital/unauth/v1/iqa/companies/TA78/accounts/1002032820/contact/CHATBOT/cases?operation=CREATECASE';

//API Names
export const PAN_ACC = 'productAccountNumber';
export const PREF_CONTACT_METHOD = 'preferredContactMethod';
export const ESC_IMPACT = 'impact';
export const FIRST_NAME = 'contactFirstName';
export const LAST_NAME = 'contactLastName';
export const EMAIL = 'contactEmail';
export const ALTERNATE_EMAIL = 'alternateEmail';
export const PHONE = 'phone';
export const SUB = 'subject';
export const DESCP = 'description';
export const ESC_LOCATOR = 'locator';
export const TAX_YEAR = 'taxYear';
export const ESC_TAX_TYPE = 'taxType';
export const ESC_JURISDICTION = 'Jurisdiction';
export const ESC_TAX_FORM = 'taxForm';
export const ENTITY_NAME_NUMBER = 'EntityNameNumber';
export const WORKAREA_NAME_NUMBER = 'WorkareaNameNumber';
export const BINDER_NAME_NUMBER = 'BinderNameNumber';
export const ESC_PERMISSION_COPY =
  'Is Permission require to retrive or copy return';
export const ESC_PERMISSION_UTILIZE =
  'Is Permission require to utilize copy of return';
export const ESC_PARTNER_ID = 'PartnerLegacySystem_ID';
export const ESC_PERMISSION_TRANSMIT =
  'Is Permission  require to be re-transmit';
export const ESC_PRODUCT_BUG = 'Is reporting a product_bug';
export const ESC_CRITICAL_PROCCESS = 'Is Preventing business critical_process';
export const ESC_WORKAROUND = 'Is there a suitable workaround';

//Form state
export const initialState = {
  [PAN_ACC]: { value: '', error: '', required: false },
  [PREF_CONTACT_METHOD]: { value: '', error: '', required: true },
  [ESC_IMPACT]: { value: '', error: '', required: true },
  [FIRST_NAME]: { value: '', error: '', required: true },
  [LAST_NAME]: { value: '', error: '', required: true },
  [EMAIL]: { value: '', error: '', required: true },
  [ALTERNATE_EMAIL]: { value: '', error: '', required: false },
  [PHONE]: { value: '', error: '', required: false },
  [SUB]: { value: '', error: '', required: true },
  [DESCP]: { value: '', error: '', required: true },
  [ESC_LOCATOR]: { value: '', error: '', required: false },
  [TAX_YEAR]: { value: '', error: '', required: false },
  [ESC_TAX_TYPE]: { value: '', error: '', required: false },
  [ESC_JURISDICTION]: { value: '', error: '', required: false },
  [ESC_TAX_FORM]: { value: '', error: '', required: false },
  [ENTITY_NAME_NUMBER]: { value: '', error: '', required: false },
  [WORKAREA_NAME_NUMBER]: { value: '', error: '', required: false },
  [BINDER_NAME_NUMBER]: { value: '', error: '', required: false },
  [ESC_PERMISSION_COPY]: { value: false, error: '', required: false },
  [ESC_PERMISSION_UTILIZE]: { value: false, error: '', required: false },
  [ESC_PARTNER_ID]: { value: '', error: '', required: false },
  [ESC_PERMISSION_TRANSMIT]: { value: false, error: '', required: false },
  [ESC_PRODUCT_BUG]: { value: false, error: '', required: false },
  [ESC_CRITICAL_PROCCESS]: { value: false, error: '', required: false },
  [ESC_WORKAROUND]: { value: false, error: '', required: false },
};
